const e=(e,r)=>e.reduce(((e,t)=>{const c=r(t);return e[c]||(e[c]=[]),e[c].push(t),e}),{});export{e as groupBy};
